module.exports = __webpack_public_path__ + "b80c9cf4e68212b31e4bfefb5b850e35.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/flat/yellow.png
// module id = 295
// module chunks = 0